// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tcol-icon {\n  position: absolute;\n  right: -14px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: help;\n}\n\n.pl-6 {\n  padding-left: 4rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
